<template>
  <app-no-menu-layout>
    <template v-if="configReady">
      <v-container>
        <v-layout wrap>
          <v-flex md12>
            <h1>{{ $t(title) }}</h1>
            <div v-html="body"></div>
            <div class="mt-5 text-xs-center">
              <v-btn color="primary" to="/opendata/form/new/1" large round dark>
                <v-icon>mdi-edit</v-icon>
                {{ $t('Iniciar Cuestionario') }}
              </v-btn>
            </div>
          </v-flex>
        </v-layout>
      </v-container>

      <v-container v-if="companiesReady">
        <v-layout wrap>
          <v-flex md12>
            <h3 class="headline my-3">
              {{ $t('Cuestionarios y documentos OpenData') }}
            </h3>
            <!-- <opendata-form-list :entities="draftEntities" @delete="deleteForm"></opendata-form-list> -->
            <div class="text-xs-right">
              <v-btn color="primary" to="/opendata/form/new/1" large dark>
                {{ $t('Nuevo Cuestionario') }}
                <v-icon>mdi-chevron-right</v-icon>
              </v-btn>
            </div>
            <opendata-my-contracted-companies
              :companies="companies"
              @delete="deleteForm"
            ></opendata-my-contracted-companies>
            <!-- <og-table>
                  <og-table-head>
                    <tr class="text-xs-left">
                      <th>{{$t('CIF')}}</th>
                      <th>{{$t('Company')}}</th>
                      <th>{{$t('Date')}}</th>
                      <th></th>
                    </tr>
                  </og-table-head>
                  <og-table-body>
                    <tr v-for="company in draftEntities" :key="company.id">
                      <td>{{company.cif}}</td>
                      <td>{{company.name}}</td>
                      <td>{{company.created_at}}</td>
                      <td class="text-xs-right"> 
                        <v-btn flat icon color="primary">
                          <v-icon>mdi-square-edit-outline</v-icon>
                        </v-btn>
                        <v-btn flat icon color="error">
                          <v-icon>mdi-delete</v-icon>
                        </v-btn>
                      </td>
                    </tr>
                  </og-table-body>
                </og-table> -->
          </v-flex>
        </v-layout>
      </v-container>
    </template>
    <router-view></router-view>
  </app-no-menu-layout>
</template>
<script>
import AppNoMenuLayout from '@/views/layouts/AppNoMenuLayout.vue';
import apiCtrl from '@/services/api/abstract/abstract-api.js';
// import OpendataFormList from "../components/OpendataFormList";
import OpendataMyContractedCompanies from '../components/OpendataMyContractedCompanies';
// import OgTable from "@/components/commons/OgTable";
// import OgTableBody from "@/components/commons/OgTableBody";
// import OgTableHead from "@/components/commons/OgTableHead";

export default {
  components: {
    AppNoMenuLayout,
    OpendataMyContractedCompanies,
    // OgTable,
    // OgTableBody,
    // OgTableHead,
    // OpendataFormList
  },
  data() {
    return {
      config: {},
      configReady: false,
      entitiesReady: false,
      draftEntities: [],
      companiesReady: false,
      companies: [],
    };
  },
  mounted() {
    this.getConfig();
    // this.getDraft();
    this.getOpendataCompanies();
  },
  computed: {
    title() {
      return this.configReady && this.config && this.config.messages
        ? this.config.messages.wellcome.title
        : '';
    },
    body() {
      return this.configReady && this.config && this.config.messages
        ? this.config.messages.wellcome.body
        : '';
    },
    currentCompany() {
      return this.$store.getters['currentCompany'];
    },
  },
  methods: {
    getOpendataCompanies() {
      this.companiesReady = false;
      const config = {
        params: {
          clavedat: this.currentCompany ? this.currentCompany.CLAVEDAT : null,
          constraint: {
            status: 'cancelled:!=',
          },
        },
      };
      this.companies = [];
      apiCtrl.get('/opendata/mycompanies', config).then(res => {
        console.log(res);
        this.companies = res.data.data;
        this.companiesReady = true;
      });
    },
    // getDraft() {
    //   this.entitiesReady = false;
    //   const config = {
    //     params: {
    //       constraint: {
    //         status: "draft:="
    //       }
    //     }
    //   };
    //   this.draftEntities = [];
    //   apiCtrl.get("/opendata-form", config).then(res => {
    //     console.log(res);
    //     this.draftEntities = res.data.data;
    //     this.entitiesReady = true;
    //   });
    // },
    deleteForm(company) {
      console.log({ DELETE: company });

      apiCtrl.delete('/opendata-form/' + company.id).then(res => {
        console.log(res);
        this.getOpendataCompanies();
      });
    },
    getConfig() {
      this.configReady = false;
      apiCtrl.get('/config/opendata').then(res => {
        this.config = res.data.data;
        this.configReady = true;
        console.log(this.config);
      });
    },
  },
};
</script>
